import React from 'react'

export type BinStoreDealItem = {
  color: string
  price: string
  day: string
  dayAbbrev: string
}

function BinStoreDealItem({ color, price, day, dayAbbrev }: BinStoreDealItem) {
  return (
    <div className="min-w-[28px] md:min-w-[100px] mx-auto cursor-pointer pt-5">
      <div
        className={`bg-${color} rounded-full w-[48px] h-[48px] md:w-[72px] md:h-[72px] flex justify-center items-center mx-auto`}
      >
        <h2 className="text-[#F5F5F5] text-[14px] md:text-[24px] font-bold">
          {price}
        </h2>
      </div>
      <p className="pt-2 text-[#132C52] text-[14px] font-extrabold md:hidden">
        {dayAbbrev}
      </p>
      <p className="hidden pt-2 text-[#132C52] text-[16px] font-extrabold md:block">
        {day}
      </p>
    </div>
  )
}
export default function BinStoreDeals({
  binDealsData,
}: {
  binDealsData: BinStoreDealItem[]
}) {
  return (
    <div>
      <div className="max-w-[1440px] px-2 mx-auto text-center md:pb-5 mt-2 md:mt-0">
        <div className="flex flex-wrap max-w-[400px] gap-x-2 md:gap-x-0 sm:max-w-xl md:max-w-3xl lg:max-w-[1076px] mx-auto">
          {binDealsData.map((item, index) => (
            <BinStoreDealItem key={index} {...item} />
          ))}
        </div>
      </div>
    </div>
  )
}
